import api from '@/client/core/api'
import { PostTagBody, PostTagResponse } from '@/typings/twitter_benchmark_campaign_posts'

import { TwBenchmarkApiResponse, TwBenchmarkApiResult, handleApiResponse } from './twBenchmarkApiError'

/**
 * POST /twitter_benchmark_campaign_posts/tags
 */
export async function postTwBenchmarkTag(
  groupId: number,
  body: PostTagBody
): Promise<TwBenchmarkApiResult<PostTagResponse>> {
  const response = await api.post<TwBenchmarkApiResponse<PostTagResponse>>(
    '/twitter_benchmark_campaign_posts/tags',
    body,
    { params: { groupId } }
  )

  return handleApiResponse<PostTagResponse>(response)
}
